import { useMemo } from "react";
import { MediaItem } from "@/types/media";

/**
 * Hook to determine the appropriate button text for model actions
 * based on the type and count of media items.
 *
 * @param mediaItems - Array of media items to analyze
 * @returns The button text to display
 */
export const useModelActionButtonText = (mediaItems: MediaItem[]): string => {
    const isVideo = useMemo(() => mediaItems.length > 0 && mediaItems[0].isVideo, [mediaItems]);

    const buttonText = useMemo(() => {
        if (isVideo) {
            return "Run On Entire Video";
        }
        return mediaItems.length === 1 ? "Review Model" : "Run On All Images";
    }, [isVideo, mediaItems.length]);

    return buttonText;
};
